module.exports = __webpack_public_path__ + "media/src/images/page01_faq04-61e4079888d709efec6befdd2e26f5cc.png";